export function redirectTo(path: string) {
  window.location.href = path;
}
